import { render, staticRenderFns } from "./clipper-upload.vue?vue&type=template&id=0423bfb6&"
import script from "./clipper-upload.vue?vue&type=script&lang=js&"
export * from "./clipper-upload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports